<template>
  <div id="mar_mian" class="relativeItem zhubox">
    <!--关闭页面的按钮-->
    <a class="close_img imgBlock" @click="close_web">
      <img src="../../assets/qixi/qixi(41).png" class="imgBlock noevents-img" />
    </a>
    <!-- 动画的盒子 -->
    <perAnima></perAnima>

    <!-- 右侧点击的按钮 活动未开始不显示 -->
    <div class="btn_con" v-if="isStart != 1">
      <div class="gui_div" @click="qieBtnFun">
        <img
          class="imgBlock noevents-img"
          src="../../assets/xiangshui/xiangshui(20).png"
        />
      </div>
    </div>

    <div class="main">
      <!-- 香水小铺 -->
      <div v-if="myOrPu == 0">
        <div class="pu_con">
          <div class="relativeItem">
            <img
              class="imgBlock noevents-img"
              src="../../assets/xiangshui/xiangshui(5).png"
            />
            <div class="pu_namme absoluteItem flex-box centerImg">
              <img
                class="puname_img imgBlock noevents-img"
                src="../../assets/xiangshui/xiaopu.png"
              />
              <div class="flex-box rgt_main">
                <div
                  class="jiang_info"
                  @click="goJiang"
                  v-if="(isStart == 3 || isStart == 4) && isAnchor == 1"
                >
                  <img
                    class="imgBlock noevents-img"
                    src="../../assets/xiangshui/xiangshui(25).png"
                  />
                </div>
                <div class="my_con" @click="goMyFun">
                  <img
                    class="imgBlock noevents-img"
                    src="../../assets/xiangshui/xiangshui(6).png"
                  />
                </div>
              </div>
            </div>
            <div
              class="pu_num absoluteItem flex-box centerImg"
              v-if="isAnchor == 2"
            >
              <p>{{ allEnergy }}</p>
              <p>当前已贡献精力值</p>
            </div>
            <div v-else class="zhu_info absoluteItem flex-box centerImg">
              <div>
                <p class="p1">{{ allEnergy }}</p>
                <p class="p2">当前已收集精力值</p>
              </div>
              <div>
                <p class="p1">{{ currentEnergy }}</p>
                <p class="p2">当前剩余精力值</p>
              </div>
            </div>
          </div>
          <div class="pu_ctr relativeItem">
            <div class="swip_main">
              <swiper
                :options="swiperOption"
                ref="lastWiper"
                class="last-swiper"
              >
                <swiper-slide
                  v-for="(n, index) in xsLists"
                  :key="index"
                  class="giftshell flex-box"
                >
                  <img
                    class="imgBlock noevents-img shui_img"
                    :src="n.good_img"
                  />
                  <p class="jl_p">{{ n.sale_price }} ( 精力 )</p>
                  <p class="name_p">{{ n.name }}</p>
                </swiper-slide>
              </swiper>
              <div class="over_box" v-show="isStart == 3 && isAnchor != 2">
                <div class="c_btn" @click="chooseFun" v-if="canLing">
                  <img
                    class="imgBlock noevents-img"
                    src="../../assets/xiangshui/chobtn.png"
                  />
                </div>
                <div class="c_btn" v-else >
                  <img
                    class="imgBlock noevents-img"
                    src="../../assets/xiangshui/overbtn.png"
                  />
                </div>
                <p>
                  请主播们认真选择，成功制成后将会获得对应香水的实物奖励哦！
                </p>
              </div>
            </div>
            <div class="s-button absoluteItem centerX flex-box">
              <!--左箭头-->
              <div class="last-s-prev lft_arr"></div>
              <!--右箭头-->
              <div class="last-s-next rgt_arr"></div>
            </div>
          </div>
          <img
            class="imgBlock noevents-img"
            src="../../assets/xiangshui/xiangshui(10).png"
          />
        </div>
      </div>

      <!-- 我的组件 活动期间的我的  isStart == 2 -->
      <div v-if="myOrPu == 1">
        <mineCom
          :listData="listData"
          :isAnchor="isAnchor"
          :allEnergy="allEnergy"
          @myPuChange="myPuChange"
        ></mineCom>
      </div>

      <!-- 总列表榜单 -->
      <div class="list_div" v-if="showRolue == 1">
        <allListCom
          :isAnchor="isAnchor"
          :btnIdx="btnIdx"
          :listData="listData"
          :showNo="showNo"
          :listText="listText"
          :titRole="titRole"
          @btnChange="btnChange($event)"
        ></allListCom>
      </div>

      <!-- 规则 只在活动未开始 isStart == 1 显示 其余一律隐藏 -->
      <div class="rol_box" v-show="isStart == 1">
        <img
          class="rg_img imgBlock noevents-img"
          src="../../assets/xiangshui/rolu01.png"
        />
        <img
          class="rg_img rg_imgbg imgBlock noevents-img"
          src="../../assets/xiangshui/rolu02.png"
        />
      </div>
    </div>
    <!-- 活动期间规则的弹窗  -->
    <div class="tc relativeItem" v-show="isStart != 1 && sRolueTc">
      <rolueCom @faCloseTc="faCloseTc"></rolueCom>
    </div>

    <!-- 选择兑换香水的 -->
    <getPer
      :item_info="item_info"
      :userinfo="userinfo"
      v-if="show_getTc"
      @close_tc="closeGetTc"
    ></getPer>
    <div class="sport_t">活动最终解释权归朱贝所有</div>
  </div>
</template>






<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import allListCom from "./all_list";
import mineCom from "./mine_com";
import rolueCom from "./rolueTc";
import getPer from "./perfumeGet";
import perAnima from "./perfume_anima";

export default {
  name: "mar_mian",
  components: {
    swiper,
    swiperSlide,
    allListCom,
    mineCom,
    rolueCom,
    getPer,
    perAnima,
  },
  data() {
    return {
      show_getTc: false,
      myOrPu: 0, // 0显示小铺  1显示我的
      xsLists: [],
      swiperOption: {
        self: this,
        centeredSlides: true,
        navigation: {
          nextEl: ".last-s-next",
          prevEl: ".last-s-prev",
          hideOnClick: true,
          hiddenClass: "last-s-hidden",
        },
        on: {
          slideChangeTransitionEnd: () => {
            //改变banner的时候重新获取列表信息
            this.swiperIdx = this.swiper.activeIndex;
            this.changeBtnFun(this.swiperIdx);
          },
        },
      },
      swiperIdx: 0,
      isAnchor: 1, //  1主播  2用户
      showRolue: 1, // 0显示规则  1显示总榜  2都不显示
      isStart: 1, //  活动状态 1未开始 2进行中 3领取 4结束
      btnIdx: 0, //主播用户榜单 切换按钮的点击
      showNo: false, // 无数据的展示
      listData: [],
      titRole: "主播",
      listText: "收集",
      canLing: false,
      sRolueTc: false, //活动规则弹窗的显示隐藏
      allEnergy: 0, //总的精力值 处理过万后的
      currentEnergy: 0, //   处理过万后的
      nowEnergy: 0, // 当前剩余的精力值  用于判断按钮的选择和置灰
      userinfo: {}, // 用户信息
      item_info: {}, //当前的香水轮播项
    };
  },
  mounted() {
    this.$tool.setTitle("闻香识女人");
    this.getMeDetail();
  },
  methods: {
    /**关闭webview */
    close_web() {
      this.$appAc.closeWeb();
    },

    // 轮播图滑动判断按钮状态
    changeBtnFun(idx) {
      if (this.nowEnergy * 1 < this.xsLists[idx].sale_price * 1) {
        this.canLing = false;
      } else {
        this.canLing = true;
      }
    },

    // 规则的点击
    qieBtnFun() {
      if (this.isStart == 1) {
        this.showRolue = 0;
        if (this.showRolue == 0) {
          window.scrollTo({ top: 600, behavior: "smooth" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        this.sRolueTc = true;
      }
    },

    // 榜单按钮的切换
    btnChange(idx) {
      this.btnIdx = idx;
      if (this.btnIdx == 0) {
        this.titRole = "主播";
        this.listText = "收集";
        this.getRankList("perfume_anchorRankIdx");
      } else {
        this.titRole = "用户";
        this.listText = "贡献";
        this.getRankList("perfume_userRankIdx");
      }
    },

    // 获取活动的额详情  以及 用户身份信息
    getMeDetail() {
      let _this = this;
      this.$jsonp(this.$apis("perfume_user"), {}, (res) => {
        _this.userinfo = res.body.data;
        _this.isAnchor = res.body.data.identity;
        _this.isStart = res.body.data.active_status;
        _this.allEnergy = _this.textOverSix(res.body.data.total_energy * 1);
        _this.currentEnergy = _this.textOverSix(
          res.body.data.current_energy * 1
        );
        _this.nowEnergy = res.body.data.current_energy * 1;
        // _this.nowEnergy = 590000;

        if (_this.isAnchor == 2) {
          //用户
          _this.titRole = "用户";
          _this.btnIdx = 1;
          _this.listText = "贡献";
          _this.getRankList("perfume_userRankIdx");
        } else {
          _this.titRole = "主播";
          _this.btnIdx = 0;
          _this.listText = "收集";
          _this.getRankList("perfume_anchorRankIdx");
        }
        _this.getPerList(); //获取所有的香水列表
        _this.judgeStart();
        _this.listData.forEach((ele) => {
          if (ele.total_energy * 1 > 99999) {
            ele.total_energy = _this.textOverSix(ele.total_energy * 1);
          }
        });
      });
    },

    getRankList(ziApi) {
      let _this = this;
      this.$jsonp(this.$apis(ziApi), {}, (res) => {
        _this.listData = [];
        _this.listData = res.data.data;
        _this.listData.forEach((ele) => {
          if (ele.total_energy * 1 > 99999) {
            ele.total_energy = _this.textOverSix(ele.total_energy * 1);
          }
        });
        if (_this.listData.length == 0) {
          _this.showNo = true;
        }
      });
    },

    textOverSix(value) {
      if (value > 99999 && value <= 999999) {
        value = (value / 1000 / 10).toFixed(2) + "w";
      } else if (value > 999999 && value <= 9999999) {
        value = (value / 1000 / 10).toFixed(2) + "w";
      } else if (value > 9999999) {
        value = (value / 100000 / 100).toFixed(2) + "kw";
      }
      return value;
    },

    getPerList() {
      let _this = this;
      this.$jsonp(this.$apis("perfume_PerList"), {}, (res) => {
        _this.xsLists = res.data.data.list;
        _this.mountJudgeBtn();
      });
    },

    // 判断活动是否开启
    judgeStart() {
      if (this.isStart == 1) {
        this.showRolue = 0;
      } else if (this.isStart == 2) {
        this.showRolue = 1;
      } else if (this.isStart == 3) {
        //领取
        this.showRolue = 1;
      } else {
        // 结束后 显示选择的按钮
      }
    },

    mountJudgeBtn() {
      if (this.nowEnergy * 1 < this.xsLists[0].sale_price * 1) {
        this.canLing = false;
      } else {
        this.canLing = true;
      }
    },

    // 点击我的操作
    goMyFun() {
      if (this.isStart == 1) {
        this.$tool.tip("当前活动还未开启~", "50%");
      } else if (this.isStart == 2) {
        this.myOrPu = 1;
        this.showRolue = 2;
      } else {
        this.$router.push("/perfume?type=" + this.isAnchor);
      }
    },

    // 点击中奖详情的操作
    goJiang() {
      this.$router.push("/perfume?type=2");
    },

    // 前往我的 组件方法
    myPuChange() {
      this.swiperIdx = 0;
      this.myOrPu = 0;
      this.showRolue = 1;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    // 选择香水的操作
    chooseFun() {
      document.querySelector(".c_btn").classList.add("anmateClass");
      setTimeout(() => {
        document.querySelector(".c_btn").classList.remove("anmateClass");
      }, 1000);

      this.item_info = this.xsLists[this.swiperIdx];
      this.item_info.promotion_amount = this.item_info.sale_price;
      this.show_getTc = true;
    },

    closeGetTc() {
      this.show_getTc = false;
      this.getMeDetail();
    },

    // 活动期间关闭规则的弹窗方法
    faCloseTc() {
      this.sRolueTc = false;
    },
  },
  computed: {
    swiper() {
      return this.$refs.lastWiper.swiper;
    },
  },
  watch: {
    sRolueTc(val) {
      if (val) {
        document.querySelector(".zhubox").style.height = "100vh";
        document.querySelector(".zhubox").style.overflowY = "hidden";
      } else {
        document.querySelector(".zhubox").style.height = "auto";
        document.querySelector(".zhubox").style.overflowY = "scroll";
      }
    },
  },
};
</script>







<style scoped>
.close_img {
  position: fixed;
  width: 9%;
  top: 8%;
  z-index: 19;
}

#mar_mian {
  width: 100%;
  min-height: 100vh;
  background-color: #9d0208;
}
#animate_box {
  height: 400px;
  width: 100%;
  background-color: #9d0208;
}

.btn_con {
  position: fixed;
  top: 50%;
  right: 0;
  width: 98px;
  z-index: 4;
}
.gui_div img {
  width: 100%;
}
.bang_div {
  text-align: right;
}

.main {
  position: relative;
  z-index: 3;
  margin-top: -90px;
}
.bot_colo {
  background-color: #9d0208;
  height: 30px;
}

.pu_con {
  margin-bottom: 16px;
}
.pu_namme {
  top: 25%;
  width: 69%;
  justify-content: space-between;
}
.puname_img {
  width: 106px;
  height: 26px;
}
.rgt_main {
  align-items: center;
}
.jiang_info {
  margin-right: 8px;
}
.my_con img,
.jiang_info img {
  width: 60px;
  height: 21px;
}
.pu_num {
  top: 60%;
  width: 69%;
  height: 30px;
  justify-content: space-between;
  align-items: center;
}
.pu_num p:nth-child(1) {
  font-size: 1.875rem;
  color: rgb(51, 51, 51);
}
.pu_num p:nth-child(2) {
  font-size: 0.84375rem;
  color: #403e3e;
}

/* 轮播区域 */
.pu_ctr {
  width: 100%;
  background: url("../../assets/xiangshui/xiangshui(15).png") repeat;
  background-size: 100% 100%;
}
.swip_main {
  width: 70%;
  margin: 0 auto;
}
.giftshell {
  height: 80%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.giftshell .jl_p {
  font-size: 0.8125rem;
  color: #fff;
  margin: 20px 0 3px;
}
.giftshell .name_p {
  font-size: 0.875rem;
  color: #ffb7b7;
}
.s-button {
  width: 75%;
  top: 32%;
  justify-content: space-between;
  z-index: 10;
}

.shui_img {
  width: 90px;
  height: 140px;
}
.lft_arr {
  width: 20px;
  height: 20px;
  border: 2px solid #ffeaea;
  border-left: 2px solid transparent;
  border-bottom: 2px solid transparent;
  transform: rotateZ(-135deg);
}
.rgt_arr {
  width: 20px;
  height: 20px;
  border: 2px solid #ffeaea;
  border-left: 2px solid transparent;
  border-bottom: 2px solid transparent;
  transform: rotateZ(45deg);
}
.swiper-button-disabled {
  opacity: 0.5;
}

/* 榜单的样式 */
.list_div {
  width: 100%;
}

/* 规则的 */
.rol_box .rg_img {
  width: 90%;
  margin: 0 auto;
}
.rg_imgbg {
  border-bottom-left-radius: 38px;
  border-bottom-right-radius: 38px;
}

/* 活动结束的显示 */
.over_box {
  width: 100%;
}
.c_btn {
  width: 100%;
  padding-top: 8px;
}

/* 选择的点击动画 */
.anmateClass {
  animation: btnAni 0.2s linear alternate;
}
.c_btn img {
  width: 110px;
  margin: 0 auto;
}
.over_box p {
  margin-top: 6px;
  font-size: 0.5625rem;
  color: #ff9292;
  text-align: center;
}

/* 主播的精力值显示样式 */
.zhu_info {
  width: 70%;
  top: 57%;
  justify-content: space-between;
}
.zhu_info .p2 {
  font-size: 0.625rem;
  color: rgb(51, 51, 51);
}
.zhu_info .p1 {
  font-size: 1.25rem;
  color: #333;
}
.sport_t {
  width: 100%;
  text-align: center;
  color: #e0cbcb;
  font-size: 0.5625rem;
  padding: 20px 0;
}
</style>